/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { variables } from '../../API/variables';
import { DecryptString, EncryptString } from '../../Helper/Encrypt/NtxEncrypt';
import { ntxAPI } from '../../API/axiosNeatex';
import axios from 'axios';

const AuthUser = localStorage?.AuthUser ? JSON.parse(DecryptString(localStorage?.AuthUser)) : null;

const initialState = {
  AuthUser: AuthUser as any,
  loading: false,
  LoadingRefreashToken: false,
  ErrorRefreashToken: null as string | null,
  error: null as string | null
};

export const LoginAction = createAsyncThunk('Login/LoginAction', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await axios.post(variables.API_URL + 'Authenticate/login', item, {
      headers: variables.ntxheader
    });
    return data;
  } catch (error: any) {
    if (error.response) {
      if (error?.response?.status === 401) {
        return rejectWithValue('401');
      } else if (error?.response?.status === 404) {
        return rejectWithValue('404');
      }
    } else if (error?.code === 'ERR_NETWORK') {
      return rejectWithValue('500');
    }
    return rejectWithValue('NetworkError');
  }
});

export const ChangePass = createAsyncThunk('Login/ChangePass', async (item: any, { rejectWithValue }) => {
  try {
    const { data } = await ntxAPI.post('Security/ChangePassword', item);
    return data;
  } catch (error: any) {
    console.error(error);
    return rejectWithValue(error.message);
  }
});

export const refreashToken = createAsyncThunk('Login/refreashToken', async (_, { rejectWithValue, dispatch }) => {
  const AuthUser = localStorage?.AuthUser ? JSON.parse(DecryptString(localStorage?.AuthUser)) : null;
  const token = AuthUser?.token;
  const refreshToken = AuthUser?.refreshToken;

  try {
    const { data } = await axios.post(
      variables.API_URL + 'Authenticate/refresh-token',
      {
        accessToken: token,
        refreshToken: refreshToken,
        businessGroupId: AuthUser?.businessGroupId || null
      },
      {
        headers: variables.ntxheader
      }
    );

    await dispatch(setAuthUser(data));
    return data;
  } catch (error) {
    return rejectWithValue('Error');
  }
});

export const LogOutAction = createAsyncThunk('Login/LogOutAction', async (_, { rejectWithValue }) => {
  try {
    const data = await ntxAPI.post('Authenticate/logout');
    return data;
  } catch (error: any) {
    return rejectWithValue(error.message);
  }
});

// export const getPersonId = (state: any) => {
//   const authUser = state?.userLogin?.AuthUser;
//   return authUser?.personId || null;
// };

// export const getBusinessGroupIdForPerson = (state: any) => {
//   return state?.userLogin?.AuthUser?.businessGroupId || null;
// };

const LoginSlice = createSlice({
  name: 'Login',
  initialState,
  reducers: {
    setAuthUser: (state, { payload }: { payload: any }) => {
      localStorage.setItem('AuthUser', EncryptString(JSON.stringify(payload)));
      state.AuthUser = payload;
    },
    LogOut: state => {
      localStorage.removeItem('AuthUser');
      state.AuthUser = null;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(LoginAction.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(LoginAction.fulfilled, state => {
        state.loading = false;
        state.error = null;
      })
      .addCase(LoginAction.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      })
      .addCase(refreashToken.pending, state => {
        state.LoadingRefreashToken = true;
        state.ErrorRefreashToken = null;
      })
      .addCase(refreashToken.fulfilled, state => {
        state.LoadingRefreashToken = false;
        state.ErrorRefreashToken = null;
      })
      .addCase(refreashToken.rejected, (state, { payload }) => {
        state.LoadingRefreashToken = false;
        state.ErrorRefreashToken = payload as string;
      });
  }
});

export const { LogOut, setAuthUser } = LoginSlice.actions;

export default LoginSlice.reducer;
